import { includesInLC } from "@datassential/platform-ui-lib";
import {
    AvailableChain,
    AvailableWorkspace,
    WORKSPACE_ENUM_VALUES,
    WorkspaceEnum,
} from "./Workspace";

export interface iAvailableTag {
    id: number;
    value: string;
}

export interface iGlobalUserData {
    hasFFChainsEnableLoginPermission: boolean;
    hasFFChainsFeaturePermission: boolean;
    hasMacAdminAccess: boolean;
    availableWorkspaces: AvailableWorkspace[];
    availableChains: AvailableChain[];
    allTags: iAvailableTag[];
    userPreferenceTags: iAvailableTag[];
}

const mapWorkspaces = (apiWorkspaces: iApiWorkspace[] | undefined | null): AvailableWorkspace[] => {
    return (apiWorkspaces ?? [])
        .map((w): AvailableWorkspace | null => {
            const apiName = w.name ?? '';
            const matchedEnum = WORKSPACE_ENUM_VALUES.find(e => includesInLC(apiName, e));
            if (!matchedEnum) return null;
            return {
                id: matchedEnum,
                workspaceId: w.workspaceId,
                name: apiName,
                displayName: w.displayName ?? '',
                canRead: w.canRead,
                isActive: w.isActive,
                isDefault: w.isDefault,
            };
        })
        .filter((w): w is AvailableWorkspace => w !== null);
};

const mapChains = (apiChains: iApiChain[] | undefined | null): AvailableChain[] => {
    return (apiChains ?? []).map(c => ({
        id: c.chainId,
        name: c.name ?? '',
        isDefault: c.isDefault,
    }));
};

export default class GlobalUserData implements iGlobalUserData {
    hasFFChainsEnableLoginPermission = false;
    hasFFChainsFeaturePermission: boolean = false;
    hasMacAdminAccess: boolean = false;
    availableWorkspaces: AvailableWorkspace[] = [];
    availableChains: AvailableChain[] = [];
    allTags: iAvailableTag[] = [];
    userPreferenceTags: iAvailableTag[] = [];

    constructor(pageData?: Window['pageData'] | null) {
        if (pageData) {
            this.hasFFChainsEnableLoginPermission = pageData?.hasSnapFeaturesProduct || false;
            this.hasFFChainsFeaturePermission = pageData?.hasSnapFeaturesFfChains || false;
            this.hasMacAdminAccess = pageData.headerUserActionsMenuItems.some(
                i => includesInLC(i.title, 'mac')
            ) || false;
            this.availableWorkspaces = mapWorkspaces(pageData.workspaces);
            this.availableChains = mapChains(pageData.chains);
            this.allTags = pageData.allTags ?? [];
            this.userPreferenceTags = pageData.userPreferenceTags ?? [];
        }
    }
}

export { WorkspaceEnum };
export type { AvailableWorkspace, AvailableChain };
